import { render } from "./AccountOnboardingRouterOutlet.vue?vue&type=template&id=c1c6e9a0&ts=true"
import script from "./AccountOnboardingRouterOutlet.vue?vue&type=script&lang=ts"
export * from "./AccountOnboardingRouterOutlet.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__